import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ShowServiceTitle',
  props: {
    serviceTitleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: String,
    performanceId: Number
  },
  data: function data() {
    return {
      showMask: false
    };
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_0dbmwuju_mv',
      cid: 'c_c21utqjf',
      abtest: 1,
      custom: {
        performance_id: this.performanceId
      }
    });
    this.setShowMask();
  },
  methods: {
    click: function click() {
      this.$emit('toggleServiceTitle');
    },
    setShowMask: function setShowMask() {
      var _this = this;
      this.$nextTick(function () {
        var clientWidth = window.document.body.clientWidth;
        var maxTagWidth = clientWidth - 48;
        var tagConEle = _this.$refs.leftWrapper;
        var showMask = false;
        if (tagConEle && tagConEle.scrollWidth > maxTagWidth) {
          showMask = true;
        }
        _this.showMask = showMask;
      });
    }
  }
};